import { render } from "./CardDetailsModal.vue?vue&type=template&id=42cf73ae&scoped=true"
import script from "./CardDetailsModal.vue?vue&type=script&lang=js"
export * from "./CardDetailsModal.vue?vue&type=script&lang=js"

import "./CardDetailsModal.vue?vue&type=style&index=0&id=42cf73ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cf73ae"]])

export default __exports__